import React  from "react";
import {
  Tabs,
} from "@material-ui/core";
import "react-dates/initialize";
import "react-dates/lib/css/_datepicker.css";
import {LinkTab} from "./components";
import {Redirect, Route, Switch, useRouteMatch} from "react-router";
import {HistoricalBalancesTable} from "./tabs/balances/HistoricalBalancesTable";

type MatchProps = {
  tab?: string
}

export const HistoricalPage = () => {
  const match = useRouteMatch<MatchProps>('/historical/:tab?')

  return (
    <>
      <Tabs
        value={match?.params.tab||0}
        indicatorColor="primary"
        textColor="primary"
      >
        <LinkTab label="Balances" href='/historical/balances' value='balances' />
      </Tabs>
      <Switch>
        <Route exact path='/historical/balances' component={HistoricalBalancesTable} />
        <Route path='*'>
          <Redirect to='/historical/balances' />
        </Route>
      </Switch>
    </>
  );
};
